/**
 * Static option lists for scope editors (workflow `/dashboard` + personal dashboard).
 */

export const MOCK_PRODUCTS = [
  'Excalibur-R-2600',
  'Snaptech-Fabric-Ultra',
  'Snaptech-Fabric-Ultra+',
  'Excalibur-X-9000',
  'RF Transceiver Gen4',
  'Power Management IC-500',
  'Sensor Hub Pro',
]

export const MOCK_PRODUCT_GROUPS = ['RF & Analog', 'Digital SoC', 'Power Management', 'Sensors']

export const MOCK_NODES = ['28nm', '16nm', '14nm', '7nm', '5nm']

export const MOCK_FOUNDRIES = ['TSMC', 'Samsung', 'GlobalFoundries']

export const MOCK_BUSINESS_UNITS = ['Mobile', 'IoT', 'Automotive', 'Consumer']

export const MOCK_TEST_STAGES = ['Wafer Sort', 'Final Test', 'System Test']
